import React, { Fragment, FunctionComponent, memo, useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import ClipToCopyIcon from '@/atoms/icons/clip-to-copy.svg'
import SuccessIcon from '@/atoms/icons/success.svg'
import { Tooltip } from '@/atoms/tooltip'
import { copyToClipboard } from '@/helpers/utils'

import { IconWrapper } from './styled-copy-to-clipboard'

interface OwnProps {
  value: string
}

type Props = OwnProps

const CopyToClipboard: FunctionComponent<Props> = memo(({ value }) => {
  const { t } = useTranslation()
  const iconRef = useRef(null)
  const [isTooltipVisible, setTooltipVisibility] = useState(false)
  const [copied, setCopied] = useState(false)
  const Icon = copied ? SuccessIcon : ClipToCopyIcon
  const tooltipText = copied ? t('tooltip.copied') : t('tooltip.copy')

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false)
      }, 3000)
    }
  }, [copied])

  const handleCopyToClipboard = (): void => {
    copyToClipboard(value)
  }

  const handleCopy = (): void => {
    handleCopyToClipboard()
    setCopied(true)
  }

  return (
    <Fragment>
      <IconWrapper
        ref={iconRef}
        $copied={copied}
        onClick={handleCopy}
        onMouseEnter={() => setTooltipVisibility(true)}
        onMouseLeave={() => setTooltipVisibility(false)}
      >
        <Icon />
      </IconWrapper>
      <Tooltip isVisible={isTooltipVisible} targetRef={iconRef} title={tooltipText} />
    </Fragment>
  )
})

CopyToClipboard.displayName = 'CopyToClipboard'

export default CopyToClipboard
